<template>
  <div class="mobile-enquiry">
    <Row>
      <Col span="24" class="modal-title">{{$t('enquiryBox.title')}}</Col>
    </Row>
    <Row>
      <Col span="24" class="modal-des">{{$t('enquiryBox.des')}}</Col>
    </Row>
    <Row>
      <Col class="modal-line"></Col>
    </Row>
    <Row>
      <Col class="nav-help">
        <p class="help-title">{{$t('enquiryBox.left.title1')}}</p>
        <div class="help-content">
          <img src="../assets/mobile/对号.svg" />
          {{$t('enquiryBox.left.text1')}}
        </div>
        <div class="help-content">
          <img src="../assets/mobile/对号.svg" />
          {{$t('enquiryBox.left.text2')}}
        </div>
        <div class="help-content">
          <img src="../assets/mobile/对号.svg" />
          {{$t('enquiryBox.left.text3')}}
        </div>
        <div class="help-content">
          <img src="../assets/mobile/对号.svg" />
          {{$t('enquiryBox.left.text4')}}
        </div>
      </Col>
    </Row>
    <Row>
      <Col>
        <Form ref="formEnquiry" :model="formEnquiry" :rules="ruleValidate">
          <FormItem>
            <Input
              v-model="formEnquiry.name"
              :placeholder="$t('enquiryBox.right.text1')"
              style="width:90%"
            />
          </FormItem>
          <FormItem prop="businessEmail">
            <Input
              v-model="formEnquiry.businessEmail"
              :placeholder="$t('enquiryBox.right.text2')"
              style="width:90%"
            />
          </FormItem>
          <FormItem>
            <Input
              v-model="formEnquiry.company"
              :placeholder="$t('enquiryBox.right.text3')"
              style="width:90%"
            />
          </FormItem>
          <FormItem>
            <Input
              v-model="formEnquiry.phoneNumber"
              :placeholder="$t('enquiryBox.right.text4')"
              style="width:90%"
            />
          </FormItem>
          <FormItem>
            <Input
              v-model="formEnquiry.help"
              :placeholder="$t('enquiryBox.right.text5')"
              style="width:90%"
            />
          </FormItem>
        </Form>
        <div class="confirm-btn" @click="send">{{$t('enquiryBox.hear')}}</div>
      </Col>
    </Row>
    <Row>
      <Col class="nav-email">
        <p class="help-title">{{$t('enquiryBox.left.title2')}}</p>
        <p class="email-des help-content">{{$t('enquiryBox.left.text5')}}</p>
        <a href="mailto:support@redteamobile.net" class="email-name">{{$t('enquiryBox.left.text6')}}</a>
        <p class="email-des help-content">{{$t('enquiryBox.left.text7')}}</p>
        <a
          href="mailto:communications@redteamobile.com"
          class="email-name"
        >{{$t('enquiryBox.left.text8')}}</a>
      </Col>
    </Row>
    <Row style="margin-top:0.45rem;padding-bottom:0.45rem;">
      <Col class="nav-find">
        <p class="help-title">{{$t('enquiryBox.left.title3')}}:</p>
        <Poptip trigger="hover" placement="top-start">
          <img src="../assets/web/微信.svg" style="margin-left:-0.1rem;width:0.68rem;" />
          <div slot="content">
            <img src="../assets/web/红茶移动微信二维码.jpg" style="width:150px" />
          </div>
        </Poptip>
        <a href="https://www.facebook.com/redteamobile" target="_Blank">
          <img src="../assets/web/Facebook.svg" style="margin-left:-0.08rem;" />
        </a>
        <a href="https://twitter.com/redteamobile" target="_Blank">
          <img src="../assets/web/Twitter.svg" />
        </a>
        <a href="https://www.linkedin.com/company/13216053/" target="_Blank">
          <img src="../assets/web/Linkedin.svg" />
        </a>
        <a href="https://www.zhihu.com/org/redteamobile/activities" target="_Blank">
          <img src="../assets/web/知乎.svg" />
        </a>
      </Col>
    </Row>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'enquiry-mobile',
  components: {},
  data() {
    return {
      value: '',
      formEnquiry: {
        name: '',
        businessEmail: '',
        company: '',
        phoneNumber: '',
        help: ''
      },
      ruleValidate: {
        businessEmail: [
          {
            required: true,
            message: this.$t('mail1'),
            trigger: 'blur'
          },
          {
            pattern: /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/,
            message: this.$t('mail2'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    clear() {
      this.formEnquiry.name = ''
      this.formEnquiry.businessEmail = ''
      this.formEnquiry.company = ''
      this.formEnquiry.phoneNumber = ''
      this.formEnquiry.help = ''
      this.$router.push({
        path: '/'
      })
    },
    send() {
      let param = this.formEnquiry
      this.$refs.formEnquiry.validate(valid => {
        if (valid) {
          this.$Message.success(this.$t('success'))
          this.$api.api.enquiry({ ...param, site: 1 }).then(res => {
            console.log(res.data.errorMsg)
            this.clear()
          })
        } else {
          if (this.formEnquiry.businessEmail) {
            this.$Message.error(this.$t('mail2'))
          } else {
            this.$Message.error(this.$t('mail1'))
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.mobile-enquiry {
  padding-top: 0.84rem;
  .modal-title {
    color: rgba(32, 49, 82, 1);
    font-family: 'Poppins-Light';
    font-size: 0.28rem;
    line-height: 0.42rem;
    text-align: center;
    margin: 0.2rem auto 0.1rem auto;
  }
  .modal-des {
    color: rgba(32, 49, 82, 1);
    font-family: Poppins-ExtraLight;
    font-size: 0.12rem;
    line-height: 0.18rem;
    text-align: center;
    margin-bottom: 0.45rem;
  }
  .modal-line {
    width: 90%;
    height: 1px;
    border-bottom: 1px solid rgba(218, 218, 218, 1);
    margin: auto;
  }
  .nav-help {
    margin: 0.4rem auto 0.5rem auto;
    text-align: left;
    padding-left: 6%;
  }
  .help-title {
    color: rgba(32, 49, 82, 1);
    font-size: 0.16rem;
    line-height: 0.25rem;
    margin-bottom: 0.15rem;
  }
  .help-content {
    color: rgba(32, 49, 82, 1);
    font-family: 'Poppins-Light';
    font-size: 0.12rem;
    line-height: 0.18rem;
    margin-top: 0.1rem;
    img {
      margin-right: 0.1rem;
    }
  }
  .email-name {
    color: rgba(207, 42, 42, 1);
    font-family: 'Poppins-Light';
    font-size: 0.12rem;
    margin-bottom: 0.05rem;
  }
  .nav-email {
    padding-top: 0.2rem;
    text-align: left;
    padding-left: 5%;
    margin-top: 0.2rem;
  }
  .nav-find {
    text-align: left;
    padding-left: 5%;
    img {
      width: 0.58rem;
    }
  }
  .confirm-btn {
    width: 3.15rem;
    height: 0.55rem;
    border-radius: 4px;
    background-color: rgba(207, 42, 42, 1);
    cursor: pointer;
    color: rgba(255, 255, 255, 1);
    font-size: 0.12rem;
    letter-spacing: 1px;
    text-align: center;
    line-height: 0.55rem;
    margin: 12% auto 0.1rem auto;
    font-family: 'Poppins-Bold';
  }
}
</style>
<style lang="less">
.mobile-enquiry .ivu-form-item {
  margin-bottom: 0.4rem !important;
}
.mobile-enquiry .ivu-input {
  border: none !important;
  border-bottom: 1px solid rgba(218, 218, 218, 1) !important;
  border-radius: 0px !important;
  font-family: 'Poppins-Light';
  font-size: 0.14rem;
}
.mobile-enquiry .ivu-input:focus {
  box-shadow: none !important;
}
</style>
